import { Typography } from "@mui/material";
import { Box } from "@mui/system";

const formatDescricao = (mensagem) => {
  return (
    <Box sx={{ p: 1 }}>
      <Typography
        sx={{
          // Texto corrido de descrição de atendimento: 13px ficava abaixo do
          // confortável para leitura longa, ainda mais no celular.
          fontSize: "0.9375rem",
          lineHeight: 1.6,
          whiteSpace: "pre-line",
          wordBreak: "break-word",
        }}
      >
        {mensagem}
      </Typography>
    </Box>
  );
};

export { formatDescricao };
